<template>
	<div class="con">
		<div class="list">
			<div v-if="List != 0" id="chart_pie" ref="chart_pie"></div>
		</div>
		<div class="sta-auto">
			<div class="new-day">今年数据</div>
			<div class="sta-auto-title">
				<div>门诊</div>
				<div>住院</div>
			</div>
			<div class="sta-form">
				<div class="sta-form-text">
					<div>收入</div>
					<div>接诊</div>
				</div>
				<div class="sta-form-text">
					<div>收入</div>
					<div>入院</div>
				</div>
			</div>
			<div class="sta-form">
				<div class="sta-form-text">
					<div>￥{{outTotal}}</div>
					<div>{{outpatRs}}</div>
				</div>
				<div class="sta-form-text">
					<div>￥{{InTotal}}</div>
					<div>{{InRYRS}}</div>
				</div>
			</div>
		</div>
		<div class="nav">
			<div class="nav-list" v-for="(item,index) in nav" @click="navBtn(item.to)">
				<img :src="item.img" />
				<div class="text">{{item.text}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'staIndex',
		data() {
			return {
				List: [],
				nav: [{
						id: 0,
						text: '领导报表',
						img: require('../assets/icon-sta1.png'),
						to: '/staDean'
					},
					{
						id: 1,
						text: '个人报表',
						img: require('../assets/icon-sta3.png'),
						to: '/staSelf'
					},
					{
						id: 2,
						text: '科室报表',
						img: require('../assets/icon-sta2.png'),
						to: '/staOffice'
					},
				],
				outTotal: '',
				outpatRs: '',
				InTotal: '',
				InRYRS: '',
			}
		},
		methods: {
			//门诊报表汇总
			GetListIndex() {
				let time = this.$timeformat.timestampToTime(new Date());
				this.GetOutpatHzReport(time);
				this.GetInpatHzReport(time);

			},

			//门诊报表汇总
			GetOutpatHzReport(e) {
				let time = e.split(" ")[0];
				time = time.split("-");

				if(time[1] == undefined) {
					time[1] = '';
				}
				if(time[2] == undefined) {
					time[2] = '';
				}
				this.$Axios.Get('/getOutpatHzReport?year=' + time[0] + '&month=&day=', null).then(res => {
					console.log(res)
					this.$store.commit('Load', false)
					if(res.code == 0) {
						let datalist = res.msg;
						this.outTotal = datalist.ZJJE_SUM;
						this.outpatRs = datalist.OUTPAT_RS;
						this.List.push({
							value: datalist.ZJJE_SUM,
							name: '门诊',
						})

						setTimeout(() => {
							this.totalPie();
						}, 300)
					}
				}).catch(err => {
					this.$store.commit('Load', false)
					console.log(err)
				})
			},

			//住院报表汇总
			GetInpatHzReport(e) {
				let time = e.split(" ")[0];
				time = time.split("-");

				if(time[1] == undefined) {
					time[1] = '';
				}
				if(time[2] == undefined) {
					time[2] = '';
				}
				this.$Axios.Get('/getInpatHzReport?year=' + time[0] + '&month=&day=', null).then(res => {
					console.log(res)
					this.$store.commit('Load', false)
					if(res.code == 0) {
						this.InTotal = res.msg.ZLZJE;
						this.InRYRS = res.msg.RYRS;
						this.List.push({
							value: res.msg.ZLZJE,
							name: '住院',
						})

					}
				}).catch(err => {
					this.$store.commit('Load', false)
					console.log(err)
				})
			},
			//饼状图
			totalPie() {

				let myChartPie = this.$echarts.init(this.$refs.chart_pie);
				if(myChartPie) {
					let dataList = this.List;
					let dataN = [];
					let dataL;
					for(let i in dataList) {
						dataN.push(dataList[i].name);
					}

					dataL = JSON.parse(JSON.stringify(dataList).replace(/INPAT_SL/g, "value").replace(/INPAT_KSMC/g, "name"))
					let option = {
						title: {
							text: '门诊收入VS住院收入',
							top: '5',
							left: 'center',
						},
						tooltip: {
							trigger: 'item',
							formatter: '{b}: {c} ({d}%)'
						},
						legend: {
							top: 'bottom',
							left: 'center',
							data: dataN,
						},
						series: [{
							type: 'pie',
							radius: ['30%', '50%'],
							center: ['50%', '45%'],
							minAngle: 10, // 设置每块扇形的最小占比
							hoverAnimation: false,
							avoidLabelOverlap: false,
							label: {
								show: false,
								position: 'center'
							},
							itemStyle: {
								normal: { //饼状图上的文本显示
									label: {
										show: true,
										position: 'outside',
										formatter: "{d}%", //数值和百分比
										textStyle: {
											fontSize: 12,
											fontWeight: 'bolder'
										}
									},

								}
							},

							labelLine: {
								show: true,
							},
							data: dataL,
						}]
					};

					myChartPie.setOption(option);
				}

			},
			navBtn(e) {
				if(e != undefined) {
					this.$router.push({
						path: e
					})
					return false;
				}
				this.$toast("功能开发中")
			},
		},
		mounted() {
			this.GetListIndex();
		},
		created() {},
	}
</script>

<style scoped>
	.con {
		width: 100%;
		height: 100%;
	}
	
	.head {
		position: relative;
		width: 100%;
		height: 15%;
		background: linear-gradient(#27BEC4, #fff);
		color: #000;
		font-size: 18px;
		font-weight: 700;
	}
	
	.head-pos {
		position: absolute;
		left: 0;
		right: 0;
		bottom: -40px;
		margin: auto;
		display: flex;
		align-items: center;
		width: 80%;
	}
	
	.user-img {
		margin-right: 20px;
		width: 100px;
		height: 100px;
		border-radius: 50%;
	}
	
	.list {
		margin-top: 20px;
	}
	
	#chart_pie {
		height: 40vh;
	}
	
	.sta-auto {
		margin-top: 10px;
		border-bottom: 1px solid #ccc;
	}
	
	.new-day {
		text-align: center;
		font-size: 15px;
	}
	
	.sta-auto-title {
		display: flex;
		justify-content: space-around;
		padding: 5px 0;
		font-size: 18px;
		font-weight: 700;
	}
	
	.sta-form {
		display: flex;
		justify-content: space-around;
	}
	
	.sta-form-text {
		display: flex;
		justify-content: space-around;
		padding: 5px 0;
		width: 50%;
		font-size: 15px;
	}
	
	.sta-form-text div {
		width: 25%;
		text-align: center;
	}
	
	.nav {
		margin-top: 10px;
		padding: 10px 5px;
		display: flex;
		justify-content: space-around;
		font-size: 14px;
		color: #000000;
	}
	
	.nav-list {
		text-align: center;
	}
	
	.nav-list img,
	.bot-list img {
		width: 30px;
		height: 30px;
	}
	
	.text {
		margin-top: 10px;
	}
</style>